import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { regenerateMessage } from 'api/ai-assistant/ai-assistant-api';
import type { StreamFetchResult } from 'api/api.config';

import toast from 'components/partials/toast/toast';

interface UseApiRegenerateMessageArgs {
  oktaUserId: string;
  conversationId: string;
  clientId: string | number;
}

interface RegenerateVariables {
  messageId: string;
  content?: string;
  onChunk?: (chunk: unknown) => void;
}

interface ApiErrorLike {
  data?: { detail?: string };
}

export const useApiRegenerateMessage = ({
  oktaUserId,
  conversationId,
  clientId,
}: UseApiRegenerateMessageArgs): UseMutationResult<
  StreamFetchResult,
  ApiErrorLike,
  RegenerateVariables
> =>
  useMutation<StreamFetchResult, ApiErrorLike, RegenerateVariables>({
    mutationFn: ({ messageId, content, onChunk }) =>
      regenerateMessage({
        oktaUserId,
        conversationId,
        messageId,
        content,
        clientId,
        onChunk,
      }),
    onError: (error) =>
      toast.error({
        title: 'Error regenerating message',
        message: error?.data?.detail,
      }),
  });
